import React from 'react';
import FiltersDropdown from '../FiltersDropdown';
import { processCodesWithFrequencies } from 'utils/filterDataProcessors';
import OpConstants from 'constants/OpConstants';

const { OP_AND, OP_OR } = OpConstants;

/**
 * Component for displaying and managing code filters
 *
 * @param {Object} props
 * @param {Array<number>} props.disabledCodeIds - Code IDs that should be disabled (shown but not toggleable)
 */
const CodesFilter = ({
  codes,
  filters,
  filterReport,
  onToggleCode,
  onClearCodes,
  onSetOperation,
  onApplyFilter,
  dropdownAbove,
  codeFilterButtonText,
  codeSubHeader,
  disabledCodeIds = [],
  defaultOpen = false,
  maxWidth,
  onDeleteFilter,
  large = false
}) => {
  const codesWithFrequencies = processCodesWithFrequencies(codes, filters, filterReport);

  // Exclude disabled codes from the button text (e.g., the required code in Code Modal)
  const checkedCodeNames = codes
    .filter(code => (filters?.codes || []).includes(code.id) && !disabledCodeIds.includes(code.id))
    .map(code => code.name);

  const anyClick = () => onSetOperation(OP_AND);
  const allClick = () => onSetOperation(OP_OR);

  return (
    <FiltersDropdown
      name="Codes"
      checkedCodeNames={checkedCodeNames}
      codes={codesWithFrequencies}
      op={filters?.op}
      onChecked={onToggleCode}
      onClearChecked={onClearCodes}
      anyClick={anyClick}
      allClick={allClick}
      applyFilter={onApplyFilter}
      dropdownAbove={dropdownAbove}
      filterButtonText={codeFilterButtonText}
      subHeader={codeSubHeader}
      totalExcerpts={filterReport?.totalExcerpts || 0}
      disabledIds={disabledCodeIds}
      defaultOpen={defaultOpen}
      maxWidth={maxWidth}
      onDeleteFilter={onDeleteFilter}
      large={large}
    />
  );
};

export default CodesFilter;
